import axios from 'axios'

export const AXIOS = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://radio.9craft.ir/v1/api',
})
